import { type ComponentPropsWithoutRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type SidebarFooterProps = ComponentPropsWithoutRef<'footer'>;

export const SidebarFooter = memo(({ className, ...restOfProps }: SidebarFooterProps) => {
  return (
    <footer
      className={cn('mx-2 flex items-center justify-between gap-2 border-t border-t-gray-5 px-2 py-3', className)}
      data-testid="SIDEBAR_FOOTER"
      {...restOfProps}
    />
  );
});

SidebarFooter.displayName = 'SidebarFooter';
